// src/lib/postLevelPopups.js

const STORAGE_KEY_PREFIX = "gwin_post_level_popups";

export const POST_LEVEL_POPUP_TYPES = Object.freeze({
  TEMPLATE_UNLOCK: "template_unlock",
  FREE_REFERRAL_UNLOCK_NOTICE: "free_referral_unlock_notice",
  LEARNING_FEEDBACK: "learning_feedback",
});

function getStorageKey(userId) {
  return `${STORAGE_KEY_PREFIX}_${userId}`;
}

function safeParseQueue(raw) {
  try {
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function normalisePopup(popup) {
  if (!popup || typeof popup !== "object") {
    return null;
  }

  const type = String(popup.type || "").trim();

  if (!type) {
    return null;
  }

  const uniqueKey =
    String(popup.uniqueKey || "").trim() ||
    `${type}:${Date.now()}:${Math.random().toString(16).slice(2)}`;

  return {
    ...popup,
    id:
      String(popup.id || "").trim() ||
      `${uniqueKey}:${Date.now()}:${Math.random().toString(16).slice(2)}`,
    type,
    uniqueKey,
    createdAt: popup.createdAt || new Date().toISOString(),
  };
}

export function getPostLevelPopupQueue(userId) {
  if (!userId || typeof window === "undefined") {
    return [];
  }

  try {
    return safeParseQueue(localStorage.getItem(getStorageKey(userId)));
  } catch {
    return [];
  }
}

export function setPostLevelPopupQueue(userId, queue) {
  if (!userId || typeof window === "undefined") {
    return [];
  }

  const cleanQueue = (Array.isArray(queue) ? queue : [])
    .map(normalisePopup)
    .filter(Boolean);

  try {
    localStorage.setItem(getStorageKey(userId), JSON.stringify(cleanQueue));
  } catch {}

  return cleanQueue;
}

export function queuePostLevelPopups(userId, popups) {
  if (!userId) {
    return [];
  }

  const existingQueue = getPostLevelPopupQueue(userId);
  const existingKeys = new Set(
    existingQueue.map((popup) => popup.uniqueKey).filter(Boolean)
  );

  const incoming = (Array.isArray(popups) ? popups : [popups])
    .map(normalisePopup)
    .filter(Boolean)
    .filter((popup) => !existingKeys.has(popup.uniqueKey));

  if (!incoming.length) {
    return existingQueue;
  }

  return setPostLevelPopupQueue(userId, [...existingQueue, ...incoming]);
}

export function removePostLevelPopup(userId, popupId) {
  if (!userId || !popupId) {
    return getPostLevelPopupQueue(userId);
  }

  const nextQueue = getPostLevelPopupQueue(userId).filter(
    (popup) => popup.id !== popupId
  );

  return setPostLevelPopupQueue(userId, nextQueue);
}

export function clearPostLevelPopupQueue(userId) {
  if (!userId || typeof window === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(getStorageKey(userId));
  } catch {}
}